// src/components/research/placeholder.js

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* Marks a section that is scaffolded but not written. Dashed rather than
   solid, and no surface fill, so it reads as an empty slot rather than as a
   card someone forgot to finish — a visitor should be able to tell at a glance
   that nothing is missing from the page, it simply has not been written yet.

   Every one of these carries a line saying what will go there. An unlabelled
   "coming soon" tells a reader nothing except that they wasted a scroll. */
const StyledPlaceholder = styled.div`
  padding: var(--space-6);
  border: 1px dashed var(--border-strong);
  border-radius: var(--border-radius);
  color: var(--text-muted);

  .status {
    display: block;
    margin-bottom: var(--space-2);
    color: var(--text-disabled);
    font-family: var(--font-sans);
    font-size: var(--fz-xs);
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  p {
    max-width: var(--measure);
    margin: 0;
    font-size: var(--fz-lg);
    line-height: var(--lh-body);
  }
`;

const Placeholder = ({ status, children }) => (
  <StyledPlaceholder>
    <span className="status">{status}</span>
    <p>{children}</p>
  </StyledPlaceholder>
);

Placeholder.propTypes = {
  status: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Placeholder.defaultProps = {
  status: 'Coming soon',
};

export default Placeholder;
